import HttpStatus from 'http-status-codes';
import React, { FC } from 'react';

import Card from '../Card';
import CardContent from '../Card/CardContent';
import Container from '../Container';
import CardError from '../Error/CardError';

const RouteNotFound: FC = () => {
  return (
    <Container>
      <Card>
        <CardContent>
          <CardError status={HttpStatus.NOT_FOUND} />
        </CardContent>
      </Card>
    </Container>
  );
};

export default RouteNotFound;
